import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  let { title, titleId, ...props } = _ref;
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: 50,
      height: 13,
      viewBox: "0 0 50 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef,
      "aria-labelledby": titleId,
      ...props,
    },
    title ? /*#__PURE__*/ React.createElement("title", { id: titleId }, title) : null,
    /*#__PURE__*/ React.createElement("g", { clipPath: "url(#clip0_1078_21)" },
      /*#__PURE__*/ React.createElement("path", {
        d: "M4.36296 2.85132H7.77961C9.61405 2.85132 ...",
        fill: "#009EE3",
      }),
      // ... rest of the <path> elements
    ),
    /*#__PURE__*/ React.createElement("defs", null,
      /*#__PURE__*/ React.createElement("clipPath", { id: "clip0_1078_21" },
        /*#__PURE__*/ React.createElement("rect", { width: 50, height: 12.1135, fill: "white" })
      )
    )
  );
}

const ForwardRef = /*#__PURE__*/ React.forwardRef(SvgPaypal);
export default ForwardRef;
export { ForwardRef as ReactComponent };